export const getAPI = () => {
   // const baseUrl = "https://localhost:44367/";
    const baseUrl = "/gdacsapi/";
    return baseUrl;
}